import { useState } from 'react';

import i18nService from '../../services/i18nService';

export default function CheckoutBar(props) {
  const [copyLinkText, setCopyLinkText] = useState(i18nService.i18n(props.locale, 'checkout.copylink'))

  const modelName = [props.selectedModel.name_pre, props.selectedModel.name, props.selectedModel.name_post].join(' ')
  const colorName = [props.selectedColor.name_pre, props.selectedColor.name, props.selectedColor.name_post].join(' ')
  const strapName = [props.selectedStrap.name_pre, props.selectedStrap.name, props.selectedStrap.name_post].join(' ')

  const watch = props.selectedColor.variantId
  const strap = props.selectedStrap.variantId
  const kit = props.selectedCase.variantId
  const checkoutUrl = `https://milus.com/cart/${watch}:1,${strap}:1,${kit}:1?discount=PERSONALMILUS`

  function copyConfigurationUrl() {
    // prepare query params
    const queryParams = [
      `model=${props.selectedModel.id}`,
      `color=${props.selectedColor.id}`,
      `strap=${props.selectedStrap.id}`,
      `case=${props.selectedCase.id}`
    ]

    // create an input field
    const textArea = document.createElement('textArea')
    textArea.value = `${document.location.href.split('?')[0]}?${queryParams.join('&')}`
    document.body.appendChild(textArea)

    // put the current location in it and copy
    textArea.select()
    document.execCommand('copy')
    if (navigator.userAgent.match(/ipad|iphone/i)) {
      let range, selection;
      range = document.createRange();
      range.selectNodeContents(textArea);
      selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      textArea.setSelectionRange(0, 999999);
    } else {
      textArea.select();
    }

    // remove the input field
    document.body.removeChild(textArea)

    setCopyLinkText(i18nService.i18n(props.locale, 'checkout.linksaved'))
    setTimeout(() => setCopyLinkText(i18nService.i18n(props.locale, 'checkout.copylink')), 750)
  }

  return (
    <div className="CheckoutBar">
      <div className="CheckoutBar-inner">
        <div className="CheckoutBar-info">
          <h3 className="CheckoutBar-name"><strong>{modelName} {colorName}</strong> & {strapName} {i18nService.i18n(props.locale, 'checkout.strap')}</h3>
          <p className="CheckoutBar-price"><small>{i18nService.translate(props.locale, 'total')}:</small> {props.selectedColor.price_from}</p>
        </div>

        <div className="CheckoutBar-action">
          <button
            type="button"
            className="CheckoutBar-reconfig"
            onClick={() => copyConfigurationUrl()}
            >
            {copyLinkText}
          </button>
          <a href={checkoutUrl} className="CheckoutBar-cta">{i18nService.i18n(props.locale, 'checkout.ordernow')}</a>
        </div>
      </div>
    </div>
  )
}
